import type { FileMetadata } from '@/types/poc/helia';

/**
 * Check whether a user has a decryption key for a given file.
 * Checks recipientEncryption (primary/P2P) then decryptionCIDS (legacy/API).
 */
export function userHasFileKey(file: FileMetadata, userId: string): boolean {
  if (file.recipientEncryption != null && file.recipientEncryption.length > 0) {
    return file.recipientEncryption.some(r => r.recipientId === userId);
  }
  if (file.decryptionCIDS != null && file.decryptionCIDS.length > 0) {
    return file.decryptionCIDS.some(d => d.userId === userId);
  }
  return false;
}
